// extracted by mini-css-extract-plugin
export default {"item":"CfyaW","readOnlyItem":"bNIzy","header":"F03l3","preview":"tu_Ey","title":"HdgLq","inner":"koSQE","addBtn":"Wmywr"};